import { render, staticRenderFns } from "./CPanel.vue?vue&type=template&id=70426b33&scoped=true&"
import script from "./CPanel.vue?vue&type=script&lang=js&"
export * from "./CPanel.vue?vue&type=script&lang=js&"
import style0 from "./CPanel.vue?vue&type=style&index=0&id=70426b33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70426b33",
  null
  
)

export default component.exports